import { Link } from "react-router-dom";
import { PopupButton } from "react-calendly";
import Tabs from './ListGroup';
import ControlledCarousel from "./Carousel";

export default function Home() {
    return (
        <>
        <div className="container-fluid row text-left bg-light pb-5">
            <div className="col-lg ms-lg-5 ps-lg-5 pt-5">
                <div className="headTextHome"><br/><span className="text-primary">Finance & Technology Consultants, Inc. </span> <br/> <br />
                    Accounting is the language of practical business life.
                </div> <br/> <br />
                
                <Link href="https://assets.calendly.com/assets/external/widget.css" rel="stylesheet" />
                <script src="https://assets.calendly.com/assets/external/widget.js" type="text/javascript" async></script>
                <PopupButton
                    className="btn btn-outline-primary p-3 ms-3 mt-3"
                    url="https://calendly.com/ftconsultants/30min?hide_event_type_details=1&hide_gdpr_banner=1"
                    rootElement={document.getElementById("root")}
                    text="Book An Appointment"
                />
            </div>
            <div className="col-lg ms-lg-5 me-lg-5 p-lg-5 mt-3 text-center">
                <ControlledCarousel /> 
                <div className="bodyText text-left">
                    Our accounting firm is here to help you and your business.
                    From any accounting needs you might have to tax planning for your upcoming goals and dreams,
                     we're here to help you achieve your dreams. Our accountants stay current with continuous 
                     seminars to ensure we are up-to-date on all of the newest information, laws, regulations, 
                     and techniques in our field. Need assistance with your tax planning? Don't we all. We've got you 
                     and your business goals and objectives in mind. You and all your tax planning needs are in expert hands.
                </div>
            </div>
        </div>

        

        <div className="container-fluid row pt-5 pb-5 bg-light">
            <div className="col-lg"></div>
            <div className="col-lg text-dark text-center ms-3 me-3 pb-3">
                <span className="fw-bold text-primary headingSmall">WELCOME <br /></span>
                <span className="bodyTextSmall">
                    Our accounting firm is here to help you and your business.
                    From any accounting needs you might have to tax planning for 
                    your upcoming goals and dreams, we're here to help you achieve your dreams.
                </span>
            </div>
            <div className="col-lg text-dark text-center ms-3 me-3 pb-3">
                <span className="fw-bold text-primary headingSmall">ACCOUNTING <br /></span>
                <span className="bodyTextSmall">
                    Our accountants stay current with continuous seminars to ensure we are 
                    up-to-date on all of the newest information, laws, regulations, and techniques in our field.
                </span>
                
            </div>
            <div className="col-lg text-dark text-center ms-3 me-3 pb-3">
                <span className="fw-bold text-primary headingSmall">PLANNING <br /></span>
                <span className="bodyTextSmall">
                    Need assistance with your tax planning? Don't we all. We've got you and your business goals and objectives in mind.
                    You and all your tax planning needs are in expert hands.
                </span>
                
                
            </div>
            <div className="col-lg"></div>
        </div>

        <Tabs />
        </>
    );
}